import {
  CheckCircle,
  Info,
  Warning,
  WarningCircle,
} from '@phosphor-icons/react';

import { SnackbarSeverity } from '../Snackbar';

export const SNACKBAR_ICONS: Record<SnackbarSeverity, JSX.Element> = {
  error: <WarningCircle weight="fill" />,
  info: <Info weight="fill" />,
  success: <CheckCircle weight="fill" />,
  warning: <Warning weight="fill" />,
};
